// extracted by mini-css-extract-plugin
module.exports = {"gifPlayer":"gifplayer_gifPlayer__xmbNv","thumbnail":"gifplayer_thumbnail__H8zqd","IconButton":"gifplayer_IconButton__nwSzP"};